<section class="set-up-delivery">

  <h2 class="h2-bold">
    QUICK QUESTION FIRST
  </h2>

  <p class="h4-semibold text-center">
    Is this delivery truly urgent, or would a subscription be a more convenient option—ensuring it arrives at your
    doorstep regularly without the hassle?
  </p>

  <div>

    <div class="set-up-delivery__card">

      <span class="material-symbols-outlined icon">
        location_on
      </span>

      <h2 class="h2-bold mt-4">
        Pet Wants Subscription
      </h2>

      <p class="h4-semibold text-center">
        Set it and forget it. Get on a Pet Wants Delivery Route!
      </p>

      <button type="button" class="btn btn-lg btn-secondary mt-4 w-100" [routerLink]="['/signup']" aria-label="close"
        (click)="close()">
        I WANT THIS
      </button>

    </div>

  </div>

  <a href="https://www.doordash.com/store/pet-wants-over-the-rhine-cincinnati-1495855/" target="_blank" rel="noopener">
    Get it now: Doordash Delivery (limited area)
  </a>

</section>